/**
 * /app/trusts/$id/risk-rating — Trust risk rating panel (route shell).
 *
 * Screen impl in `./risk-rating-screen.tsx`, lazy-loaded. This is a trust
 * sub-tab (not a first-paint route); the FIC RMCP rating panel + the
 * reassessment modal + the audit-derived changelog are sizeable, so the screen
 * is code-split out of the initial bundle (200 kB budget) following the same
 * manual `lazyRouteComponent` pattern as the audit sub-tab. Do NOT
 * plugin-regenerate routeTree.gen.ts — it imports only `Route` from here, which
 * stays valid.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/risk-rating')({
  component: lazyRouteComponent(() => import('./risk-rating-screen'), 'RiskRatingScreen'),
});
